<div class="row">
  <div class="col-md-12">
      <yt-fin-dokument-stavka-inline-update #baseInlineUpdate></yt-fin-dokument-stavka-inline-update>
  </div>
</div>
<div class="row">
  <div class="col-md-12">
      <yt-fw-default-detail-list-inline [Model]="modelData.MainList.DetailList[0]" [ParentPropertyName]="_parentPropertyName" [ParentPropertyValue]="_parentPropertyValue" [Disabled]="!_parentPropertyValue || _parentPropertyValue <= 0" (Items)="setItems($event)"></yt-fw-default-detail-list-inline>
  </div>
  <div class="col-lg-12">
    <!--Ovde treba da se dodaju ukupne vrednosti. Detalji sa Dejom.-->
    <yt-fin-dokument-sum [Items]="tempItems"></yt-fin-dokument-sum>
</div>
</div>